import { SYSTEM_EXPAND } from 'common/actions/row-groups/types';
import { RowsGroups } from 'common/reducers/rowsGroups/types';
import { AllocationWeightedShareValue } from 'common/types/valuation';
import {
  RANGE_SENSITIVITY_SPREADSHEET_COMPANY_SECTION_HEADER,
  RANGE_SENSITIVITY_SPREADSHEET_FUND_SECTION_HEADER,
  RANGE_SENSITIVITY_SPREADSHEET_SHARE_SECTION_HEADER,
} from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getArrayValue } from 'utilities';

export interface GetRangeSensitivityRowGroupsInitialStateParams {
  /** Used for fund section only (entries with `fund`). Share rows use {@link securitiesCount}. */
  nonEmptyWeightedShareValues: AllocationWeightedShareValue[] | undefined;
  /** Primary cap table security count — share section rows mirror Equity Allocation. */
  securitiesCount: number;
}

/**
 * Initial expand/collapse state for row groups (must match rows where {@link hasSubRows} is true in customRowConfig).
 */
export function getRangeSensitivityRowGroupsInitialState(
  params: GetRangeSensitivityRowGroupsInitialStateParams
): RowsGroups {
  const { securitiesCount, nonEmptyWeightedShareValues } = params;

  const state: RowsGroups = {
    [RANGE_SENSITIVITY_SPREADSHEET_COMPANY_SECTION_HEADER]: SYSTEM_EXPAND,
  };

  const fundEntries = getArrayValue(nonEmptyWeightedShareValues)?.filter(wsv => wsv.fund) ?? [];
  if (fundEntries.length > 0) {
    state[RANGE_SENSITIVITY_SPREADSHEET_FUND_SECTION_HEADER] = SYSTEM_EXPAND;
  }

  if (securitiesCount > 0) {
    state[RANGE_SENSITIVITY_SPREADSHEET_SHARE_SECTION_HEADER] = SYSTEM_EXPAND;
  }

  return state;
}
